import React, { useEffect, useState, useRef, useCallback } from 'react';
import Loader from '../../CustomComponents/Loader';
import { useDispatch, useSelector } from 'react-redux';
import { SAVING, appTheme, retrieveData } from '../../../helpers/utils/Utils';
import { GetApiHeadersWithBearer, GetRequest } from '../../../network/NetworkUtils';
import { STATUS_SUCCESS_CODE, TRANSACTIONS, CHECKING, GET_DDA_DETAILS, SAVINGS, SAVING_CARD_CODE, GET_MANAGE_SAVING_GOAL, GET_MANAGE_SAVING_GOAL_V2, SAVINGS_GOALS_BALANCE, SAVINGS_GOALS, GET_CLIMB_FEATURES } from '../../../network/URLConstants';
import HomeLayout from '../../Layout/HomeLayout';
import HomeHeader from '../../CustomComponents/HomeHeader';
import DynamicCard from '../../CustomComponents/DynamicCard';
import { width } from '../../CustomComponents/DynamicCard/DynamicCardStyles';
import TransactionItemWidget from '../../CustomComponents/TransactionItemWidget';
import { Tabs, Tab } from '../../CustomComponents/TabsComponent';
import LineBreaks, { CheckingAndSavingsHeader, AccountDetailsHeder, copyToClipboard, formatDateToMMDDYYYY, addLineBreaks, ManageSavingsGoal, dashBoardformatDate, formatTransactionGroupDate, groupTransactionsByDate } from '../../../utils';
import { GroupedTransactionsList } from '../../CustomComponents/GroupedTransactions';
import { useTranslation } from 'react-i18next';
import FilterSlider from '../../CustomComponents/Slider';
import { useNavigate, useLocation } from 'react-router-dom';
import { withOidcSecure, useOidcUser, useOidcAccessToken, useOidc } from '@axa-fr/react-oidc'
import moment from 'moment';
import logFirebaseEvents from '../../LogFirebaseEvents';
import Tooltip from '../../Tootltip';
import debounce from 'lodash.debounce';
import Cookies from 'js-cookie';
import VictorIcon from '../../../assets/kudzu-plus-images/VectorIconBlue.png'
import GoalsWidget from '../../CustomComponents/GoalsWidget';
import { SAVING_GAOLS_TRANSACTIONS } from '../../../network/URLConstants';
import SavingsTransactionCard from './SavingsTransactionCard';
import { useDocumentTitle } from '../../../hooks/useDocumentTitle';


const Savings = (props) => {
  const { hideLayout, Radius, isTransactionsPage, onAccountSwitch, hasSpendingAccount, hasSavingsAccount } = props;

  const savingValues = [
    {
      total_savings: 122.22,
      remaining_savings: 123.23,
      saving_goal_total: 1234.11,
    },
  ];

  const currentPath = window.location.pathname;
  const location = useLocation();
  const pageSize = location.pathname === '/home' ? 5 : 10;
  const isMountedRef = useRef(false);
  const navigate = useNavigate();
  const currentDate = new Date();
  const minDate = new Date(currentDate);
  minDate.setMonth(currentDate.getMonth() - 6); // Minimum date is 6 months ago
  const maxDate = new Date(); // Maximum date is today
  const { t } = useTranslation(); // Hook to access translation functions
  const userProfile = useSelector(state => JSON.parse(state.userProfile));
  const accessTokenToApi = useSelector(state => state.accessToken);
  const cards = useSelector(state => JSON.parse(state.userCards));
  const [cardData, setCardData] = useState([]);
  const [transactioncardData, setTransactionCardData] = useState([]);
  const defaultFilterData = { minAmnt: '0', maxAmnt: '500', debit: true, credit: true, minDate: moment(new Date(currentDate).setMonth(currentDate.getMonth() - 6)).format('MM-DD-YYYY'), maxDate: moment(new Date()).format('MM-DD-YYYY') };
  const [filterData, setFilterData] = useState(defaultFilterData);
  const [isLoading, setIsLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [CardNumber, setCardNumber] = useState('');
  const [CardBalance, setCardBalance] = useState('');
  const [CardText, setCardText] = useState('');
  const [showItems, setShowItems] = useState(false);
  const [totalItemsCount, setTotalItemsCount] = useState(0);
  const [savingsAccountNumber, setCheckingAccountNumber] = useState('*********'); //Account Number
  const [savingsRoutingNumber, setCheckingRoutingNumber] = useState('*********');
  const [accountCopied, setAccountCopied] = useState(false);
  const [routingCopied, setRoutingCopied] = useState(false);
  //const [pageSize, setPageSize] = useState(10);
  const [isViewAllClicked, setIsViewAllClicked] = useState(false);
  const [showFilterOverlay, setShowFilterOverlay] = useState(false);
  const [userName, setUserName] = useState('');
  // const cardDetails = useSelector(state => state.selectedCardDetails);
  const [cardDetails, setCardDetails] = useState({})
  const [selectedTab, setSelectedTab] = useState(t('ActivityTab'));
  const SearchFiltervalue = useSelector(state => state.SearchFiltervalue);
  const [isFilterApplied, setIsFilterApplied] = useState(false)
  const [savingsGoalsItems, setSavingsGoalsItems] = useState([])
  const [goalsTabDisable, setGoalsTabDisable] = useState(false)
  const [labelDisable, setLabelDisable] = useState(false);
  const [savingsActivity, setSavingsActivity] = useState(false);
  const [savingsTotalData, setSavingsTotalData] = useState([{
    savingsBalance: '',
    savingsRemainingBalance: '',
    totalSavingsBalance: ''
  }]);
  const isPrimrayKey = cards !== null ? cards !== null ? cards[0].CardKey : 0 : 0;
  const [SearchV, setSearchV] = useState('');
  const dispatch = useDispatch();
  const kudzuPlusTrue = useSelector(state => state.kudzuPlusTrue);
  const appThemeData = appTheme(kudzuPlusTrue)
  const climbFeatures = useSelector(state => state.climbFeatures);
  const enabledClimbings = climbFeatures?.filter((response) => response?.enabled === true);
  const issavingsGoalEligible = enabledClimbings?.find(item => item?.code === SAVINGS_GOALS);

    useDocumentTitle(t('page_title_savings_account'));

  // Effect for fetching data userProfile
  useEffect(() => {
    if (userProfile !== undefined && userProfile != null) {
      setUserName(userProfile.FirstName);
    }

  }, []);


  ///navigation
  const handleNavigateToSavings = () => {
    // debugger;
    navigate('/Transactions')
  };

  const aplliedTabFunction = async (appliedTab) => {
    setSelectedTab(appliedTab);
    if (appliedTab == t('ActivityTab')) {
      const fetchData = async () => {
        await fetchInitialTransactionData(SAVINGS, currentPage, defaultFilterData, SearchV);
      };
      fetchData();
      setSearchV("")
    }
    else if (appliedTab == t('saving_goal')) {
      // GetGoalData()
      await fetchInitialData(SAVINGS, currentPage, defaultFilterData, SearchV);
      setSearchV("")
    }
  }

  const footerStyles = "font-hanken-grotesk cursor-pointer text-center pt-8 text-[var(--foot-home-clr)] font-bold lg:text-[18px] md:text-[17px] sm:text-[14px] text-[14px] leading-[18px] underline absolute md:bottom-24 bottom-[3rem] left-1/2 -translate-x-1/2 cursor-pointer";
  const footerStylesNoRecords = "font-hanken-grotesk cursor-pointer text-left pt-8 text-[#4B70B9] font-[500] md:font-[500] md:font-[600] lg:text-[18px] md:text-[18px] sm:text-[12px] text-[14px] leading-[18px] opacity-[75%]";

  //search
  const debouncedSubmitSearch = useCallback(
    debounce(async (SearchVal, currentFilterData) => {
      setIsLoading(true);
      setSearchV(SearchVal);
      // const cardKey = cards?.[0].CardKey;
      var cardKey;
      for (var i = 0; i < cards?.length; i++) {
        if (cards?.[i].AccountTypeBit63 == SAVING_CARD_CODE) {
          cardKey = cards?.[i].CardKey;
          break;
        }
      }
      const transactionData = await fetchTransactionsData(cardKey, currentFilterData, 1, SearchVal);
      const savingTransactionData = await fetchSavingTransactionsData(cardKey, currentFilterData, 1, SearchVal)
      setCardData(transactionData);
      setTransactionCardData(savingTransactionData)
      setIsLoading(false);

      setTimeout(() => {
        dispatch({ type: 'CLOSE_ICON_FROM_STORE', payload: { closeIconFromStore: true } });
      }, 200)
    }, 600), // 3000ms debounce time (30 seconds)
    [cards, filterData]
  );

  const handleSubmitSearch = (value) => {
    if (value === '') {
      debouncedSubmitSearch.cancel();
      debouncedSubmitSearch('', filterData);
    } else {
      debouncedSubmitSearch(value, filterData);
    }
  };
  const Footer = () => {
    return (
      <div>
        {(currentPath === '/home') && cardData.length > 0 && showItems && (
          <div className={footerStyles} onClick={handleNavigateToSavings}>
            {(t('viewAll'))}
          </div>
        )}

        {showItems && (currentPath === '/' + SAVINGS + '' || currentPath === '/Transactions') && totalPages !== 0 && cardData.length > 0 && (
          <div className={footerStyles} onClick={handleLoadMore}>
            {(t('viewAll'))}
          </div>
        )}
        {/* {showItems && cardData.length == 0 && totalPages == 0 && (
          <div className={`${footerStylesNoRecords} ${currentPath === '/home' ? 'text-center text-[#559C7E]' : ' text-[#4B70B9] text-left'}`}>
            {(t('notransaction'))}
          </div>
        )} */}
      </div>
    );
  };

  const getAccountNumberDetails = async (cardType, cardkey) => {
    if (cardkey == null || cardkey == undefined) {
      return
    }
    setIsLoading(true);
    let url = GET_DDA_DETAILS + cardkey;
    const deviceId = await retrieveData('updatedDeviceId');
    const headers = await GetApiHeadersWithBearer(deviceId, accessTokenToApi);
    var response = await GetRequest(url, headers)
    setTimeout(() => {
      setIsLoading(false)
    }, 500);
    var responseObj = JSON.parse(response);
    if (responseObj.ResponseCode == STATUS_SUCCESS_CODE) {
      if (responseObj.Response != undefined) {
        if (cardType == SAVINGS) {
          setCheckingAccountNumber(responseObj.Response.ExternalSVAID != undefined ? responseObj.Response.ExternalSVAID : '--');
          setCheckingRoutingNumber(responseObj.Response.RoutingNumber != undefined ? responseObj.Response.RoutingNumber : '--')
        }

      }
    } else {
      var arrMessages = responseObj.Messages;
      var message = arrMessages[0];
      var displayText = message.DisplayText;
    }
  }


  const fetchSavingTransactionsData = async (cardKey, filterData, currentPage, SearchV) => {
    setGoalsTabDisable(false)

    if (cardKey == null || cardKey == undefined) {
      return
    }
    if (SearchV == undefined) {
      SearchV = '';
    }
    try {
      setIsLoading(true);
      const deviceId = await retrieveData('updatedDeviceId');
      const headers = await GetApiHeadersWithBearer(deviceId, accessTokenToApi);
      const formattedMaxAmt = filterData.maxAmnt == '500' ? `${filterData.maxAmnt}+` : filterData.maxAmnt;
      const response = await GetRequest(
        TRANSACTIONS(cardKey, filterData.debit, filterData.credit, filterData.minAmnt, formattedMaxAmt, filterData.minDate, filterData.maxDate, pageSize, currentPage, SearchV),
        headers
      );
      const responseObj = JSON.parse(response);
      if (responseObj.ResponseCode === STATUS_SUCCESS_CODE) {
        setIsLoading(false);
        setShowItems(true);
        const totalPages = responseObj.Response.TotalPages;
        const RespcurrentPage = responseObj.Response.CurrentPage;
        const TotalItemsCount = responseObj.Response.TotalItemsCount;
        setTotalPages(totalPages);
        setCurrentPage(RespcurrentPage);
        setTotalItemsCount(TotalItemsCount);
        if (currentPage * pageSize <= TotalItemsCount) setIsViewAllClicked(false); // Show "Load More" button
        else setIsViewAllClicked(true);
        const transactionItems = responseObj?.Response?.Items;
        if (transactionItems !== undefined && transactionItems.length > 0) {
          setLabelDisable(false);
          setSavingsActivity(false)
        } else {
          setLabelDisable(true);
          setSavingsActivity(true)

        }
        return transactionItems;
      } else {
        setIsLoading(false);
        return [];
      }
    } catch (error) {
      setIsLoading(false);
      return [];
    }
  };


  const fetchTransactionsData = async (cardKey, filterData, currentPage, SearchV) => {
    setGoalsTabDisable(false)

    if (cardKey == null || cardKey == undefined) {
      return
    }
    if (SearchV == undefined) {
      SearchV = '';
    }
    try {
      setIsLoading(true);
      const deviceId = await retrieveData('updatedDeviceId');
      const headers = await GetApiHeadersWithBearer(deviceId, accessTokenToApi);
      const formattedMaxAmt = filterData.maxAmnt == '500' ? `${filterData.maxAmnt}+` : filterData.maxAmnt;
      const response = await GetRequest(
        SAVING_GAOLS_TRANSACTIONS(cardKey, filterData.minDate, filterData.maxDate, pageSize, currentPage, SearchV),
        headers
      );
      const responseObj = JSON.parse(response);
      if (responseObj.ResponseCode === STATUS_SUCCESS_CODE) {
        setIsLoading(false);
        setShowItems(true);
        const totalPages = responseObj.Response.TotalPages;
        const RespcurrentPage = responseObj.Response.CurrentPage;
        const TotalItemsCount = responseObj.Response.TotalItemsCount;
        setTotalPages(totalPages);
        setCurrentPage(RespcurrentPage);
        setTotalItemsCount(TotalItemsCount);

        if (currentPage * pageSize <= TotalItemsCount) setIsViewAllClicked(false); // Show "Load More" button
        else setIsViewAllClicked(true);



        // if (totalPages < 0) {
        //   setIsViewAllClicked(true); // Show "Load More" button
        // } else {
        //   setIsViewAllClicked(false); // Hide "Load More" button
        // }
        const transactionItems = responseObj?.Response?.Items;
        if (transactionItems !== undefined && transactionItems.length > 0) {
          setLabelDisable(false);
          setSavingsActivity(false)
        } else {
          setLabelDisable(true);
          setSavingsActivity(true)

        }
        return transactionItems;
      } else {
        setIsLoading(false);
        return [];
      }
    } catch (error) {
      setIsLoading(false);
      return [];
    }
  };

  const displayViewAllBasedOnTotalItemCounts = () => {
    if (showItems) {
      if (currentPage * pageSize <= totalItemsCount) setIsViewAllClicked(false); // Show "Load More" button
      else setIsViewAllClicked(true);

    }
  }


  useEffect(() => {
    // debugger;
    if (!isMountedRef.current) {
      const fetchData = async () => {
        await fetchInitialData(SAVINGS, currentPage, defaultFilterData, SearchV);
        await fetchInitialTransactionData(SAVINGS, currentPage, defaultFilterData, SearchV)
      };
      fetchData();
      isMountedRef.current = true;
    }
  }, []);


  ///get transactions data

  const fetchInitialData = async (cardType, currentPage, filterData, SearchV) => {
    // debugger;
    setIsLoading(true);
    if (SearchV == undefined) {
      SearchV = '';
    }
    var cardKey;
    for (var i = 0; i < cards?.length; i++) {
      if (cards?.[i].AccountTypeBit63 == SAVING_CARD_CODE) {
        setCardText(cards?.[i].NickName ? cards?.[i].NickName : cards?.[i].AccountTypeName);
        setCardNumber(cards?.[i].CardDisplayNumber);
        setCardBalance(cards?.[i].Balance);
        cardKey = cards?.[i].CardKey;
        setCardDetails(cards?.[i])
      }
    }
    //  alert(SAVINGS)
    // Fetch account details only once and store them in state
    if (savingsAccountNumber !== '' && savingsRoutingNumber !== '') {
      await getAccountNumberDetails(cardType, cardKey);
    }

    const transactionData = await fetchTransactionsData(cardKey, filterData, currentPage, SearchV);

    // If it's the first page, set the transaction data as it is
    if (currentPage === 1) {
      setCardData(transactionData);
    } else {
      // If it's not the first page, append the new transactions to the existing data
      setCardData((prevCardData) => [...prevCardData, ...transactionData]);
    }

    setIsLoading(false);
  };


  const fetchInitialTransactionData = async (cardType, currentPage, filterData, SearchV) => {
    setIsLoading(true);
    if (SearchV == undefined) {
      SearchV = '';
    }
    var cardKey;
    for (var i = 0; i < cards?.length; i++) {
      if (cards?.[i].AccountTypeBit63 == SAVING_CARD_CODE) {
        setCardText(cards?.[i].NickName ? cards?.[i].NickName : cards?.[i].AccountTypeName);
        setCardNumber(cards?.[i].CardDisplayNumber);
        setCardBalance(cards?.[i].Balance);
        cardKey = cards?.[i].CardKey;
        setCardDetails(cards?.[i])
      }
    }
    if (savingsAccountNumber !== '' && savingsRoutingNumber !== '') {
      await getAccountNumberDetails(cardType, cardKey);
    }
    const transactionData = await fetchSavingTransactionsData(cardKey, filterData, currentPage, SearchV);
    if (currentPage === 1) {
      setTransactionCardData(transactionData);
    } else {
      setTransactionCardData((prevCardData) => [...prevCardData, ...transactionData]);
    }
    setIsLoading(false);
  };


  //load more data

  const handleLoadMore = async () => {
    //  debugger;
    const newCurrentPage = currentPage + 1;
    setCurrentPage(newCurrentPage);
    try {
      await fetchInitialData(SAVINGS, newCurrentPage, filterData);
      await fetchInitialTransactionData(SAVINGS, newCurrentPage, filterData)
    } catch (error) {
      // Handle error, if any
      console.error(error);
      setIsLoading(false);
    }
  };

  const onCloseFilter = () => {
    // setIsViewAllClicked(true);
    if (currentPath === '/home') {
      setShowFilterOverlay(true);
      handleNavigateToSavings();
      logFirebaseEvents("Home", "filter_Closed", "filter_Closed", "", "");
    } else {
      setShowFilterOverlay((prevState) => !prevState);
      logFirebaseEvents("Savings", "filter_Closed", "filter_Closed", "", "");
      // if(showFilterOverlay) setIsViewAllClicked(false)
    }
  }
 
  ////filters
  const handleFilterClick = () => {
    dispatch({ type: 'SEARCH_FILTER_VALUE', payload: { SearchFiltervalue: global.searchValueFromGlobal } });
    // setIsViewAllClicked(true);
    if (currentPath === '/home') {
      setShowFilterOverlay(true);
      handleNavigateToSavings();
      logFirebaseEvents("Home", "filter_Clicked", "filter_Clicked", "", "");
    } else {
      setShowFilterOverlay((prevState) => !prevState);
      logFirebaseEvents("Savings", "filter_Clicked", "filter_Clicked", "", "");
      // if(showFilterOverlay) setIsViewAllClicked(false)
    }
  };

  useEffect(() => {
    if (showFilterOverlay) setIsViewAllClicked(true)
    else displayViewAllBasedOnTotalItemCounts();
  }, [showFilterOverlay])
  //load more data

  const handleApplyFilters = async (data) => {
    dispatch({ type: 'SEARCH_FILTER_VALUE', payload: { SearchFiltervalue: global.searchValueFromGlobal } });
    logFirebaseEvents("Savings", "Apply_filters_clicked", "Apply_filters_clicked", "", "");
    //debugger;
    setFilterData(data);
    setIsFilterApplied(true)

    // Convert boolean values to "Y" (true) or "N" (false)
    const formattedDebit = data.debit ? 'true' : 'false';
    const formattedCredit = data.credit ? 'true' : 'false';


    // Ensure that minAmnt and maxAmnt are numbers
    const formattedMinAmnt = Number(data.minAmnt);
    const formattedMaxAmnt = Number(data.maxAmnt) === 500 ? `${Number(data.maxAmnt)}+` : Number(data.maxAmnt);

    // const formattedMaxAmnt = Number(data.maxAmnt);

    const formattedMinDt = data.minDate;
    const formattedMaxDt = data.maxDate;


    // Construct the data object to be passed to the API
    const formattedFilterData = {
      minAmnt: formattedMinAmnt,
      maxAmnt: formattedMaxAmnt,
      debit: formattedDebit,
      credit: formattedCredit,
      minDate: formattedMinDt,
      maxDate: formattedMaxDt
    };

    // Clear existing data
    setCardData([]);
    setTransactionCardData([])
    setCurrentPage(1);

    // Fetch data for each card type (e.g., checking) with the updated filterData
    await fetchInitialData(SAVINGS, 1, formattedFilterData, global.searchValueFromGlobal);
    await fetchInitialTransactionData(SAVINGS, 1, formattedFilterData, global.searchValueFromGlobal);
    setShowFilterOverlay(false);

  };

  const handleClearFilters = async () => {
    logFirebaseEvents("Savings", "Reset_filters", "Reset_filters", "", "");
    //alert('Clear Filters');
  };


  ////////////end of the transactions date fetching

  const accountNumberCopiedClicked = () => {
    //debugger;
    logFirebaseEvents("savings", "Account_number_copied", "Account_number_copied", "", "");
    copyToClipboard(savingsAccountNumber)
    setAccountCopied(true);
    setTimeout(() => {
      setAccountCopied(false);
    }, 2000);

  }
  const routingNumberCopiedClicked = () => {
    logFirebaseEvents("savings", "routing_Number_Copied", "routing_Number_Copied", "", "");
    // debugger;
    copyToClipboard(savingsRoutingNumber)
    setRoutingCopied(true);
    setTimeout(() => {
      setRoutingCopied(false);
    }, 2000);
  }

  ///home header 
  const getHeaderText = () => {
    return (
      <>
        {(addLineBreaks(t('basic_account_sideHeading').replace("{TYPE}", 'savings')))}
      </>
    )
    // return (`${t('hello_user').replace("{USER}", userName)}\n${t('basic_account_sideHeading').replace("{TYPE}", SAVINGS)}`)
  };


  const steps = [
    'Tap here to search by transaction name',
    'Tap here for more search tool',
  ];
  const [currentStepSaving, setCurrentStepSaving] = useState(0);
  const [isTooltipVisibleSaving, setIsTooltipVisibleSaving] = useState(false);

  // useEffect(() => {
  //   const tooltipStateSaving = sessionStorage.getItem("tooltipState_Saving");
  //   console.log('Initial tooltipSaving:', tooltipStateSaving);

  //   if (tooltipStateSaving === null || parseInt(tooltipStateSaving) < steps.length) {
  //     setCurrentStepSaving(parseInt(tooltipStateSaving) || 0);
  //     setIsTooltipVisibleSaving(true);
  //   } else {
  //     setIsTooltipVisibleSaving(false);
  //   }

  // }, [steps.length]);

  useEffect(() => {
    const tooltipCookieNameForSaving = `tooltipState_Saving${cards[0].CardKey}`;
    const tooltipStateSaving = Cookies.get(tooltipCookieNameForSaving);
    console.log('Initial tooltipStateSaving:', tooltipStateSaving);

    if (tooltipStateSaving === undefined || parseInt(tooltipStateSaving) < steps.length) {
      setCurrentStepSaving(parseInt(tooltipStateSaving) || 0);
      setIsTooltipVisibleSaving(true);
    } else {
      setIsTooltipVisibleSaving(false);
    }
  }, [steps.length]);

    const activityCancelTransaction = async (transactionData) => {
        let cardKey;
        let spendingCardDetails;
        for (let i = 0; i < cards?.length; i++) {
            if (cards?.[i].AccountTypeBit63 == SAVING_CARD_CODE) {
                setCardText(cards?.[i].NickName ? cards?.[i].NickName : cards?.[i].AccountTypeName);
                setCardNumber(cards?.[i].CardDisplayNumber);
                setCardBalance(cards?.[i].Balance);

                cardKey = cards?.[i].CardKey;
                spendingCardDetails = cards?.[i];
                break;
            }
        }

        if (cardKey == undefined || cardKey == null) {
            return;
        }

        try {
            const cancelTransactionDetails = {
                ...transactionData,
                cardDetails: spendingCardDetails,
            };

            dispatch({
                type: 'CANCEL_TRANSFER_DETAILS',
                payload: {
                    cancelTransactionDetails: JSON.stringify(cancelTransactionDetails),
                },
            });
            navigate('/transactionCardActivity');
        } catch (error) {
            return [];
        }
    };


  const handleNextSaving = () => {
    const nextStep = currentStepSaving + 1;
    console.log('Current Saving Step:', currentStepSaving);
    console.log('Next Saving Step:', nextStep);
    if (nextStep < steps.length) {
      setCurrentStepSaving(nextStep);
    } else {
      handleGotItSaving();
    }
  };

  const handlePreviousSaving = () => {
    const prevStep = currentStepSaving - 1;
    console.log('Current Saving Step:', currentStepSaving);
    console.log('Previous Saving Step:', prevStep);
    if (prevStep >= 0) {
      setCurrentStepSaving(prevStep);
    }
  };

  const handleGotItSaving = () => {
    console.log('Got It Saving');
    setIsTooltipVisibleSaving(false);
    // sessionStorage.setItem("tooltipState_Saving", steps.length.toString());
    const tooltipCookieNameForSaving = `tooltipState_Saving${cards[0].CardKey}`;
    Cookies.set(tooltipCookieNameForSaving, 'true', { expires: 1825 }, steps.length.toString());
  };

  const handleGotitWithSearchClickForSaving = () => {
    setIsTooltipVisibleSaving(false);
    // sessionStorage.setItem("tooltipState_Saving", 2);
    const tooltipCookieNameForSaving = `tooltipState_Saving${cards[0].CardKey}`;
    Cookies.set(tooltipCookieNameForSaving, 'true', { expires: 1825 }, 2);
  }

  const showTooltipStatusForSaving = useSelector(state => state.showTooltipForSavings);


  const GetGoalData = async () => {
    const deviceId = await retrieveData("updatedDeviceId");
    const headers = await GetApiHeadersWithBearer(deviceId, accessTokenToApi);
    const savingsAccount = cards.find(account => account.AccountTypeBit63 == SAVING_CARD_CODE);
    const url = GET_MANAGE_SAVING_GOAL_V2(savingsAccount.CardKey, 1);
    try {
      const response = await GetRequest(url, headers);
      const responseJson = await JSON.parse(response);
      if (responseJson.ResponseCode == STATUS_SUCCESS_CODE) {
        const data = responseJson?.Response?.Items
        if (data != null && data.length > 0) {
          setLabelDisable(false);
          setGoalsTabDisable(false)
          setSavingsGoalsItems(data)
        } else {
          setSavingsGoalsItems([])
          setGoalsTabDisable(true)
          setLabelDisable(true)
        }

      }
      else {
        var arrMessages = responseJson.Messages;
        var message = arrMessages[0];
        var displayText = message.DisplayText;
        // showAlertModal(true, t("oops_exclamation"), '', displayText, true, true, t('home'), t('back_to_card_services'), true, require('../../../../assets/images/warning.png'), '', false, false, true, false)

        console.log("y374347t7t54635t46r7gfyfgrvdgcvdgjvcdsvjcghdsvjcvcvh", responseJson);
      }
    }
    catch (error) {
      console.log("error", error);
    }
  };
  const [savingsBalance, setSavingsBalance] = useState(0);

  const getSavingGoalsAccountBalance = async () => {
    const deviceId = await retrieveData("updatedDeviceId");
    const headers = await GetApiHeadersWithBearer(deviceId, accessTokenToApi);
    const savingsAccount = cards.find(account => account.AccountTypeBit63 == SAVING_CARD_CODE);
    if (!savingsAccount) {
      return;
    }
    var url = SAVINGS_GOALS_BALANCE.replace('{cardkey}', savingsAccount.CardKey)
    const response = await GetRequest(url, headers);
    const responseObj = JSON.parse(response)
    if (responseObj.ResponseCode == STATUS_SUCCESS_CODE) {
      setSavingsBalance(responseObj.Response.goalsBalance);
      setSavingsTotalData([{
        savingsBalance: responseObj.Response.goalsBalance,
        savingsRemainingBalance: responseObj.Response.savingsAccountBalance,
        totalSavingsBalance: responseObj.Response.goalsBalance + responseObj.Response.savingsAccountBalance
      }])
    }
  }

  const handleClimbFeatures = async () => {
    if (isPrimrayKey == undefined || isPrimrayKey == null) {
      return
    }
    //  debugger;
    setIsLoading(true);
    const deviceId = await retrieveData('updatedDeviceId')
    const headers = await GetApiHeadersWithBearer(deviceId, accessTokenToApi);
    const url = GET_CLIMB_FEATURES.replace('{CARD_KEY}', isPrimrayKey)
    const response = await GetRequest(url, headers);
    const responseJson = JSON.parse(response);
    if (responseJson.ResponseCode === STATUS_SUCCESS_CODE) {
      dispatch({ type: 'UPDATE_CLIMB_FEATURE', payload: { climbFeatures: responseJson.Response } })
      setIsLoading(false);
    } else {
      return [];
    }

  }

  useEffect(() => {
    handleClimbFeatures()
    getSavingGoalsAccountBalance()
  }, [])

  const renderCalls = () => {
    <>
      <Tab label={t("saving_goal")}>
        {Array.isArray(savingsGoalsItems) && savingsGoalsItems.length > 0 ?
          <GoalsWidget savingsGoalsItems={savingsGoalsItems} />
          :
          <div className={`${footerStylesNoRecords} ${currentPath === '/home' ? 'text-center text-[var(--text-clr-no-transactions)]' : ' text-[var(--text-clr-no-transactions)] text-left'}`}>
            {(t('notransaction'))}
          </div>
        }
      </Tab>
    </>
  }


  //  alert(showTooltipStatus);

  // Group transactions by date with pending transactions on top (matching Checking page format)
  const renderGroupedTransactions = (items) => {
    if (!items || items.length === 0) {
      return null;
    }

    // Use utility function to format dates with i18n support
    const formatDateFn = (value) => formatTransactionGroupDate(value, t);

    // Use utility function to group transactions (Savings uses both 'APP' and 'Pending' status)
    const groupedData = groupTransactionsByDate(
      items, 
      formatDateFn, 
      'TransactionTime', 
      'StatusCode', 
      'APP'
    );

    // Also check for 'Pending' status items
    const additionalPending = items.filter(item => item.Status === 'Pending' && item.StatusCode !== 'APP');
    const combinedPendingItems = [...groupedData.pendingItems, ...additionalPending];

    const finalGroupedData = {
      ...groupedData,
      pendingItems: combinedPendingItems
    };

    // Use reusable component to render grouped transactions
    return (
      <GroupedTransactionsList 
        items={items}
        groupedData={finalGroupedData}
        onCBKDataReceived={() => {}} // Savings doesn't have CBK functionality
        onCancelTransaction={activityCancelTransaction}
      />
    );
  };

  const dynamicHomeCard = (
    <DynamicCard
      header={false}
      footer={isViewAllClicked}
      footerContent={<Footer />}

      CardRadius={currentPath === '/' + SAVINGS + '' ? Radius : false}
      cardWidth={width.homeCardWithFilters}
      HeaderRadius={currentPath === '/' + SAVINGS + '' ? Radius : false}
      backgroundColor={'--navbar-bg-savings'}
      isWhite={appThemeData.isWhiteBgForCard}
      isDarkForKudzu={appThemeData.isDarkBgForCard}
      HeaderContent={
        <CheckingAndSavingsHeader
          cardText={CardText}
          amount={(Number(CardBalance) + Number(savingsBalance)).toFixed(2)}
          cardNum={CardNumber}
          ImageIcon={appThemeData.isBlueIconForSavings}
          handleCopyClick={accountNumberCopiedClicked}
          handleCopyRoutingNumberClick={routingNumberCopiedClicked}
          accountNumber={savingsAccountNumber}
          routingNumber={savingsRoutingNumber}
          cardDetails={cardDetails}
          onClick={() => { }}
          isTransactionsPage={isTransactionsPage}
          onAccountSwitch={onAccountSwitch}
          hasSpendingAccount={hasSpendingAccount}
          hasSavingsAccount={hasSavingsAccount}
        />
      }
    >
    <div className="flex flex-col w-full mt-[1rem]">
      {(currentPath === "/" + SAVINGS + "" || currentPath === '/Transactions') && (
        <>
          <div
            className="hidden sm:block md:block md:h-[216px] h-[145px] 
        md:px-16 sm:px-[2.5rem] pl-[2.6rem] pr-8"
          >
            <AccountDetailsHeder
              AccountNo={savingsAccountNumber}
              routingNo={savingsRoutingNumber}
              accountCopiedProps={accountCopied}
              routingCopiedProps={routingCopied}
              handleCopyClick={accountNumberCopiedClicked}
              handleCopyRoutingNumberClick={routingNumberCopiedClicked}
              contentBetween={true}
              topBorder={false}
              bottomBorder={showFilterOverlay ? false : true}
              isCopyblack={true}
            />
          </div>
            {(kudzuPlusTrue && issavingsGoalEligible) &&
              <div
                className="hidden sm:block md:block md:h-[216px] h-[145px] 
          md:px-16 sm:px-[2.5rem] pl-[2.6rem] pr-8"
              >
                <ManageSavingsGoal
                  // savingGoalValues={savingValues}
                  savingGoalValues={savingsTotalData}
                  contentBetween={true}
                  topBorder={false}
                  bottomBorder={showFilterOverlay ? false : true}
                />
              </div>}
          </>
        )}
      </div>

      {showItems && !showFilterOverlay && (
        <div className='md:pb-[9rem] pb-[5rem] mt-6 sm:px-0 px-10 relative'>
          {isTooltipVisibleSaving && showTooltipStatusForSaving && currentPath !== '/home' && (
            <>
              {(cardData && cardData.length > 0) ? (
                <Tooltip
                  steps={steps}
                  onNext={handleNextSaving}
                  onPrevious={handlePreviousSaving}
                  onGotIt={handleGotItSaving}
                  currentStep={currentStepSaving}
                />
              ) : null}
            </>

          )}
          <p className='insights flex items-center md:px-16 sm:px-[2.5rem] space-x-6 justify-between font-hanken-grotesk text-[var(--primary-text-cards)] uppercase lg:text-[13px] md:text-[12px] sm:text-[12px] text-[12px] font-[600] tracking-[2px] md:pb-8 pb-4'>
            {currentPath === '/home' ? t('recent_transactions') : t('transactions')}
          </p>
          {!kudzuPlusTrue && <Tabs selectedTab={selectedTab} updateActiveTab={aplliedTabFunction} cardType={t('savings')} isEnabled={(!isFilterApplied && transactioncardData.length === 0 && SearchV == "") ? false : true} onFilterClick={handleFilterClick} handleSubmitSearch={handleSubmitSearch} handleGotitWithSearchClickForSaving={handleGotitWithSearchClickForSaving} goalsDisable={goalsTabDisable} savingsActivity={savingsActivity} labelDisable={labelDisable} hideSearchAndFilterBtn={currentPath === '/home'}>
            <Tab label={t('ActivityTab')} >
              {(transactioncardData && transactioncardData.length > 0) ? (
                renderGroupedTransactions(transactioncardData)
              ) :
                (transactioncardData.length === 0 && SearchV) ? <div
                  className={`${footerStylesNoRecords} ${currentPath === '/home' ? 'text-center text-[var(--text-clr-no-transactions)]' : 'text-left text-[var(--text-clr-no-transactions)]'}`}
                >{t('no_Transactions_Found_Invalid')}</div> :
                  <div className={`${footerStylesNoRecords} ${currentPath === '/home' ? 'text-center text-[var(--text-clr-no-transactions)]' : ' text-[var(--text-clr-no-transactions)] text-left'}`}>
                    {(t('notransaction'))}
                  </div>}
            </Tab>
          </Tabs>}

          {kudzuPlusTrue &&
            <>
              <Tabs
                selectedTab={selectedTab}
                updateActiveTab={aplliedTabFunction}
                cardType={t('savings')}
                isEnabled={
                  selectedTab === t('ActivityTab')
                    ? !(!isFilterApplied && transactioncardData.length === 0 && SearchV === "")
                    : !(!isFilterApplied && cardData.length === 0 && SearchV === "")
                }
                onFilterClick={handleFilterClick}
                handleSubmitSearch={handleSubmitSearch}
                handleGotitWithSearchClickForSaving={handleGotitWithSearchClickForSaving}
                goalsDisable={goalsTabDisable}
                savingsActivity={savingsActivity}
                labelDisable={labelDisable}
                hideSearchAndFilterBtn={currentPath === '/home'}
              >
              <Tab label={t('ActivityTab')}>
                {(transactioncardData && transactioncardData.length > 0) ? (
                  renderGroupedTransactions(transactioncardData)
                ) : (
                  transactioncardData.length === 0 && SearchV ? (
                    <div className={`${footerStylesNoRecords} ${currentPath === '/home' ? 'text-center text-[var(--text-clr-no-transactions)]' : 'text-left text-[var(--text-clr-no-transactions)]'}`}>
                      {t('no_Transactions_Found_Invalid')}
                    </div>
                  ) : (
                    <div className={`${footerStylesNoRecords} ${currentPath === '/home' ? 'text-center text-[var(--text-clr-no-transactions)]' : 'text-left text-[var(--text-clr-no-transactions)]'}`}>
                      {t('notransaction')}
                    </div>
                  )
                )}
              </Tab>

              <Tab label={t("saving_goal")}>
                {(cardData && cardData.length > 0) ? cardData.map((data) => (
                    <SavingsTransactionCard transactionData={data} />
                )) : (
                  cardData.length === 0 && SearchV ? (
                    <div className={`${footerStylesNoRecords} ${currentPath === '/home' ? 'text-center text-[var(--text-clr-no-transactions)]' : 'text-left text-[var(--text-clr-no-transactions)]'}`}>
                      {t('no_Transactions_Found_Invalid')}
                    </div>
                  ) : (
                    <div className={`${footerStylesNoRecords} ${currentPath === '/home' ? 'text-center text-[var(--text-clr-no-transactions)]' : 'text-left text-[var(--text-clr-no-transactions)]'}`}>
                      {t('You_do_not_have_any_set_savings_goals')}
                    </div>
                  )
                )}
              </Tab>
            </Tabs>
            </>
          }
        </div>
      )}

      {showFilterOverlay &&
        (
          <FilterSlider
            applyFilters={handleApplyFilters}
            filterClose={onCloseFilter}
            handleReset={handleClearFilters}
            appliedFilters={filterData}
            selectedTab={selectedTab}
          />

        )
      }
    </DynamicCard>

  );



  return (
    <>
      {hideLayout ? (
        dynamicHomeCard
      ) : (
        <HomeLayout>
          <HomeHeader heading={getHeaderText()} isHeaderCaption={true} />
          <div className='flex flex-col lg:w-[860px] md:w-[860px] sm:w-[464px] w-[100%]
          animate__animated animate__fadeInRight '>
            {dynamicHomeCard}
            {isLoading && <Loader />}
          </div>
        </HomeLayout>
      )}
    </>
  );
};

export default withOidcSecure(Savings);
